import React from "react";
export function Footer() {
  return <footer className="bg-ink-900 pb-28 pt-10 text-cream/70 md:pb-10" data-id="element-127" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-6xl px-5 text-center text-xs leading-relaxed md:px-8" data-id="element-128" data-mp="3ggaqtvj9sd5g">
        <p className="font-display text-base font-semibold text-cream" data-id="element-129" data-mp="32onkt3zizq9h">De cero a tu empresa de limpieza</p>
        <p className="mx-auto mt-3 max-w-2xl" data-id="element-130" data-mp="36qhf8uj4ny17">
          Los resultados dependen de cómo apliques las estrategias, tu mercado y tu constancia. Consultá las
          condiciones de compra, cancelación y reembolso en nuestra tienda antes de finalizar tu pedido.
        </p>
        <p className="mt-4" data-id="element-131" data-mp="3lelyq0q08dl1">© {new Date().getFullYear()} De cero a tu empresa de limpieza. Todos los derechos reservados.</p>
      </div>
    </footer>;
}